/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PersonaleResponseDTO,
  ProblemDetails,
} from '../models/index';
import {
    PersonaleResponseDTOFromJSON,
    PersonaleResponseDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetPersonaleRequest {
    date?: Date;
}

export interface GetPersonaleByIdRequest {
    idPersonale: number;
}

export interface GetPersonaleByIdClienteRequest {
    idCliente?: number;
}

export interface GetPersonaleByIdCommessaRequest {
    idCommessa?: number;
}

/**
 * 
 */
export class PersonaleApi extends runtime.BaseAPI {

    /**
     */
    async apiPersonaleMeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaleResponseDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Personale/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaleResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonaleMeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaleResponseDTO> {
        const response = await this.apiPersonaleMeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonaleRaw(requestParameters: GetPersonaleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonaleResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Personale`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonaleResponseDTOFromJSON));
    }

    /**
     */
    async getPersonale(requestParameters: GetPersonaleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonaleResponseDTO>> {
        const response = await this.getPersonaleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonaleByIdRaw(requestParameters: GetPersonaleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaleResponseDTO>> {
        if (requestParameters['idPersonale'] == null) {
            throw new runtime.RequiredError(
                'idPersonale',
                'Required parameter "idPersonale" was null or undefined when calling getPersonaleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Personale/{idPersonale}`.replace(`{${"idPersonale"}}`, encodeURIComponent(String(requestParameters['idPersonale']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaleResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPersonaleById(requestParameters: GetPersonaleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaleResponseDTO> {
        const response = await this.getPersonaleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonaleByIdClienteRaw(requestParameters: GetPersonaleByIdClienteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonaleResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idCliente'] != null) {
            queryParameters['idCliente'] = requestParameters['idCliente'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Personale/getPersonaleByIdCliente`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonaleResponseDTOFromJSON));
    }

    /**
     */
    async getPersonaleByIdCliente(requestParameters: GetPersonaleByIdClienteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonaleResponseDTO>> {
        const response = await this.getPersonaleByIdClienteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonaleByIdCommessaRaw(requestParameters: GetPersonaleByIdCommessaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonaleResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idCommessa'] != null) {
            queryParameters['idCommessa'] = requestParameters['idCommessa'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Personale/getPersonaleByIdCommessa`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonaleResponseDTOFromJSON));
    }

    /**
     */
    async getPersonaleByIdCommessa(requestParameters: GetPersonaleByIdCommessaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonaleResponseDTO>> {
        const response = await this.getPersonaleByIdCommessaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
